"use client"

import { useSyncExternalStore } from "react"

import { PayOverTime } from "@/components/marketing/pay-over-time"

/** The phone breakpoint of the flagship card: at or under it the pay-later
 *  lines drop under the price and centre, above it they sit in the column
 *  beside the price, left-aligned. Keep it equal to the card's own
 *  `@media (max-width:680px)` in instances.tsx. */
const PHONE = "(max-width: 680px)"

function subscribe(onChange: () => void) {
  const mq = window.matchMedia(PHONE)
  mq.addEventListener("change", onChange)
  return () => mq.removeEventListener("change", onChange)
}

/**
 * The providers' pay-later lines in the flagship card's price row.
 *
 * PayPal takes its text alignment as a render option and Stripe lays its line
 * out from the left of its own box, so CSS alone cannot move the lines from
 * the left-aligned column beside the price (desktop) to the centred seat under
 * the price (phone). The seat is read from the viewport here and the block
 * remounts when it changes. The server renders nothing, because the viewport
 * is unknown there and both providers paint on the client anyway.
 *
 * Every word and figure stays the providers' own (components/marketing/
 * pay-over-time.tsx). This sits beside the price, never on the button.
 */
export function PriceSidePayOverTime({ amountCents }: { amountCents: number }) {
  const phone = useSyncExternalStore<boolean | null>(
    subscribe,
    () => window.matchMedia(PHONE).matches,
    () => null,
  )
  if (phone === null) return null
  const align = phone ? "center" : "left"
  return <PayOverTime key={align} amountCents={amountCents} align={align} />
}
